import script from "./NavbarSesion.vue?vue&type=script&setup=true&lang=js"
export * from "./NavbarSesion.vue?vue&type=script&setup=true&lang=js"

import "./NavbarSesion.vue?vue&type=style&index=0&id=8d20ecf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d20ecf2"]])

export default __exports__